import { Sport } from "../redux/slices";

export const getBallLabelFromSport = (sport: Sport): string => {
  switch (sport) {
    case Sport.BASKETBALL:
    case Sport.SOCCER:
      return "Ball";

    case Sport.HOCKEY:
      return "Puck";

    case Sport.NO_SPORT:
      throw new Error(`Invalid sport: ${sport}`);
  }
};

export const getPlayingSurfaceLabelFromSport = (sport: Sport): string => {
  switch (sport) {
    case Sport.BASKETBALL:
      return "Court";
    case Sport.HOCKEY:
      return "Rink";
    case Sport.SOCCER:
      return "Pitch";
    case Sport.NO_SPORT:
      throw new Error(`Invalid sport: ${sport}`);
  }
};

export const getSetLabelFromSport = (sport: Sport): string => {
  switch (sport) {
    case Sport.BASKETBALL:
      return "Sets";
    case Sport.HOCKEY:
    case Sport.SOCCER:
      return "Formations";
    case Sport.NO_SPORT:
      throw new Error(`Invalid sport: ${sport}`);
  }
};
